module.exports = __webpack_public_path__ + "static/media/brushy.ee3d5d3a.jpg";